import React from 'react';
import ReactMarkdown from 'react-markdown';
import { BrowserRouter, Link, Routes, Route, Switch, useParams } from "react-router-dom";

import ContentIndexPage from './ContentIndexPage'
import TopNavigation from 'src/components/TopNavigation';
import {wordNav} from './words_constants.js'
const allWords = require('src/content/words/index.json');

function WordsContentIndexPage(props) {
    let content = allWords.filter(w => w.visibility);
    let wordsHeader = (
        <React.Fragment>
        <header>
        <TopNavigation links={wordNav}/>
        </header>
        <header className="tag-header">
        </header>
        </React.Fragment>
    );

    return <ContentIndexPage allData={content} pageType="words" header={wordsHeader} />;
}

export default WordsContentIndexPage;

